import { createFieldsCroppingFetcher } from './api/fieldsCroppingFetcher';
import { createDndcCroppingFetcher } from './api/dndcCroppingFetcher';

export default () => {
    const mscCroppingFetcher = createFieldsCroppingFetcher();
    const dndcCroppingFetcher = createDndcCroppingFetcher();

    return { dndcCroppingFetcher, mscCroppingFetcher };
};
